// extracted by mini-css-extract-plugin
export default {"input":"styles-module--input--c788a","hollow":"styles-module--hollow--9949e","invalid":"styles-module--invalid--3d8ce"};